import { VNode, h } from "preact";
import { InputLine } from "./InputLine.js";
import { UIFormProps } from "../FormProvider.js";

export function InputPhone(props: UIFormProps<string>): VNode {
  return <InputLine type="tel" {...props} />;
}
